(function () {
    'use strict';
    var controllerId = 'userRoleAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'risorse', 'risorsaId', 'ruoli', 'ruoloId', userRoleAdd]);

    function userRoleAdd($scope, datacontext, sectionMenu, $uibModalInstance, risorse, risorsaId, ruoli, ruoloId) {
        $scope.userRole = {};
        $scope.risorse = risorse;
        $scope.ruoli = ruoli;


        if (risorsaId) {
            $scope.risorsaId = risorsaId;
            $scope.userRole.risorsaId = risorsaId;
        }

        if (ruoloId) {
            $scope.ruoloId = ruoloId;
            $scope.userRole.ruoloId = ruoloId;
        }


        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.userRole)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            console.log('addItem');
            return datacontext.userRole_add(item.risorsaId, item.roleId).then(function (data) {
                if (!data) return null;

                return data;
            });
        }
    }
})();